import * as React from "react"
import { LinkButton } from "gatsby-interface"
import { Link } from "@gatsbyjs/reach-router"
import * as styles from "./not-active.css"
import gatsbyBot from "./assets/gatsby-bot-valhalla.svg"
import { EarlyAccess, Feature } from "./early-access"

const SHARED_DESCRIPTION = (
  <>
    <b>Valhalla: The Enterprise Content Hub</b> is a must-have for organizations
    wanting to update their web architecture while also dealing with the reality
    of Legacy APIs.
  </>
)

const SHARED_LEARN_MORE_LINK = (
  <Link to="/products/valhalla-content-hub" className={styles.docLink}>
    Want to learn more?
  </Link>
)

const SHARED_HEADING = `We love that you’re curious!`

export type DataLayerNotActiveProps = {
  hasEarlyAccess: boolean
  organizationId: string
  siteId: string
  isFreeTierPlan?: boolean | null
  isAgencyOrEnterpriseTierPlan?: boolean | null
}

export function DataLayerNotActive({
  hasEarlyAccess,
  organizationId,
  siteId,
  isFreeTierPlan,
  isAgencyOrEnterpriseTierPlan,
}: DataLayerNotActiveProps) {
  if (!hasEarlyAccess && isAgencyOrEnterpriseTierPlan) {
    return (
      <Layout heading={SHARED_HEADING}>
        <p>
          {SHARED_DESCRIPTION} It provides a centralized repository that gives
          enterprises an architecture for managing content across a variety of
          sources — making it accessible via a unified GraphQL API for building
          content sites, eCommerce platforms, and both web and native
          applications.
        </p>
        <p>
          We want YOU to get in on the fun! Chat with our team to learn how you
          can benefit.
        </p>
        <EarlyAccess
          btnLabel="Chat with our team"
          feature={Feature.DataLayer}
          siteId={siteId}
          workspaceId={organizationId}
        />
        {SHARED_LEARN_MORE_LINK}
      </Layout>
    )
  }

  if (hasEarlyAccess && !isFreeTierPlan) {
    return (
      <Layout heading="Content Hub disabled">
        <p>{SHARED_DESCRIPTION}</p>
        <LinkButton
          to={`/dashboard/${organizationId}/sites/${siteId}/settings/content-hub#dataLayer`}
        >
          Enable Content Hub
        </LinkButton>
        {SHARED_LEARN_MORE_LINK}
      </Layout>
    )
  }

  return (
    <Layout heading={SHARED_HEADING}>
      <p>{SHARED_DESCRIPTION}</p>
      <p>
        It can be accessed on our Agency and Enterprise tiers. <br />
        <b>Want to learn more?</b>
      </p>
      <LinkButton to={`/products/valhalla-content-hub`}>
        Dive in here
      </LinkButton>
    </Layout>
  )
}

type LayoutProps = {
  heading: string
  children: React.ReactNode
}

function Layout({ heading, children }: LayoutProps) {
  return (
    <div className={styles.root}>
      <img src={gatsbyBot} alt="" />
      <h2 className={styles.heading}>{heading}</h2>
      {children}
    </div>
  )
}
